import type { IObservableArray } from 'mobx';
import { toJS } from 'mobx';

import type { FacebookCampaign, FacebookDisplayCreative } from '@feathr/blackbox';

export function validateStepCreatives(
  campaign: FacebookCampaign,
  creatives: IObservableArray<FacebookDisplayCreative>,
): string[] {
  const campaignErrors = campaign.validate(
    ['destination_url', 'facebook_page_id', 'publisher_platforms', 'targeted_countries'],
    false,
  ).errors;
  if (campaignErrors.length) {
    return campaignErrors;
  }
  if (creatives.filter((t) => t.get('is_enabled')).length < 1) {
    return ['You need at least one enabled creative.'];
  }
  return creatives
    .map((crv) => {
      const errors = toJS(
        crv.validate(
          [
            'width',
            'height',
            'spec',
            'destination_url',
            'name',
            'caption',
            'duration',
            'ad_video_id',
            'ad_video_thumbnail',
          ],
          false,
        ).errors,
      );

      if (errors.length) {
        return errors[0];
      }
      return undefined;
    })
    .filter((msg) => !!msg) as string[];
}
